import React, { useEffect, useState } from "react";
import moment from "moment";
import URL from "../../../../Main/url";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import formatCountryName from "../../../../Main/formatCountryName ";

const A4SO = React.forwardRef((props, ref) => {
  const { values } = props;

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
        .a4-so-container {
          @page {
            size: A4;
            margin: 4% 4% 12% 4%;
          }
          .a4-so-footer {
            font-size: 12px;
            white-space: pre;
            position: fixed;
            bottom: 10mm;
            left: 6%;
          }
          .a4-so-footer-right {
            font-size: 12px;
            white-space: pre;
            position: fixed;
            bottom: 10mm;
            right: 6%;
          }
        }
      `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    injectScopedStyles();
  }, []);

  return (
    <div className="flex justify-center a4-so-container" ref={ref}>
      <div>
        <div className="text-black-900 text-[0.65rem] text-center">
          <div className="text-center">
            {values?.branch?.image ? (
              <div className="flex justify-center">
                <div className="text-xl pb-2">
                  <img
                    className="w-[50px] h-[50px]"
                    src={`${URL}/uploads${values?.branch?.image}`}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="text-medium text-xl">{values?.branch?.name}</div>
            <div className="text-medium">{values?.branch?.category}</div>
          </div>
        </div>
        <div className="text-black-900 text-[0.65rem] text-center pt-4">
          <span>
            Email&nbsp;:&nbsp;
            {values?.branch?.email ? values?.branch?.email + ", " : ""}
            &nbsp;
          </span>
          <span>
            Phone&nbsp;:&nbsp;
            {values?.branch?.phone ? values?.branch?.phone : ""}
            &nbsp;
          </span>
          <div>
            {values?.branch?.area ? values?.branch?.area + ", " : ""}
            {values?.branch?.city ? values?.branch?.city + ", " : ""}
            {values?.branch?.country
              ? formatCountryName(values?.branch?.country)
              : ""}
          </div>
          <div>VATIN&nbsp;:&nbsp;{values?.branch?.tax}</div>
        </div>
        <hr className="my-4 border-t-black-900 border-black" />
        <div className="text-medium text-xl text-center">SALES ORDER</div>
        <div className="text-xs pb-6">
          <div className="flex justify-between">
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>Customer</td>
                    <td className="px-2">:</td>
                    <td className="">
                      {values?.customer?.name
                        ? values?.customer?.name
                        : "Walk-in-customer"}
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td className="px-2">:</td>
                    <td className="">
                      {values?.customer?.phone ? values?.customer?.phone : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {values?.customer?.city
                        ? values?.customer?.city + ", "
                        : " "}
                      {values?.customer?.state}
                    </td>
                  </tr>
                  <tr>
                    <td>{formatCountryName(values?.customer?.country)}</td>
                  </tr>
                  <tr>
                    <td>VAT</td>
                    <td className="px-2">:</td>
                    <td className="">
                      {values?.customer?.tax ? values?.customer?.tax : "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>SO No</td>
                    <td className="px-2">:</td>
                    <td className="text-right">#INV-{values?.number}</td>
                  </tr>
                  <tr>
                    <td>Date</td>
                    <td className="px-2">:</td>
                    <td className="text-right">
                      {moment?.(values?.date)?.format?.("DD-MM-YYYY")}
                    </td>
                  </tr>
                  {values?.due_date ? (
                    <tr>
                      <td>Due</td>
                      <td className="px-2">:</td>
                      <td className="text-right">
                        {moment?.(values?.due_date)?.format?.("DD-MM-YYYY")}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {values?.created_by?.name ? (
                    <tr>
                      <td>Billed By</td>
                      <td className="px-2">:</td>
                      <td className="text-right">{values?.created_by?.name}</td>
                    </tr>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="">
          <table className="w-full">
            <thead className="bg-black">
              <tr className="text-sm">
                <th className="text-white text-left py-2 pl-3">S.NO</th>
                <th className="text-white text-left p-2">DESCRIPTION</th>
                <th className="text-white text-center p-2">PRICE</th>
                <th className="text-white text-center p-2">QTY</th>
                <th className="text-white text-right pr-2">TOTAL</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {values?.details?.map((value, index) => (
                <tr key={index} className="border-b border-gray-300">
                  <td className="text-center">{index + 1}</td>
                  <td>{value?.name}</td>
                  <td className="text-center">
                    {value?.sale_price?.toFixed(3) || "0.000"}
                  </td>
                  <td className="text-center">{value?.quantity}</td>
                  <td className="text-right pr-2">
                    {value?.total?.toFixed(3)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={3}></th>
                <th className="text-right p-2">Total</th>
                <td className="text-right p-2">{values?.total?.toFixed(3)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div
          className="pt-4 text-regular text-sm"
          dangerouslySetInnerHTML={{ __html: values?.note }}
        />
      </div>
    </div>
  );
});

export default A4SO;
